var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "email_svg__a",
    d: "M.026.1h38.82v30.503H.026z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "email_svg__b",
    d: "M0 .097h49.912v34.722H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.478 13.97a1.387 1.387 0 0 0 0 2.774h8.319a1.386 1.386 0 1 0 0-2.773h-8.319Zm0-5.545a1.386 1.386 0 1 0 0 2.773h16.637a1.386 1.386 0 1 0 0-2.773H12.478ZM8.318.106h33.275a2.773 2.773 0 0 1 2.773 2.773v24.956a2.773 2.773 0 0 1-2.773 2.773H8.32a2.773 2.773 0 0 1-2.773-2.773V2.879A2.773 2.773 0 0 1 8.319.106Z",
    fill: "#5298F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.198 12.785 22.758 16.436 22.758-16.436a1.386 1.386 0 0 1 2.198 1.124V41.7a5.546 5.546 0 0 1-5.546 5.546H5.546A5.546 5.546 0 0 1 0 41.7V13.91a1.387 1.387 0 0 1 2.198-1.124",
    fill: "#394A54"
  }))));
};

export default SvgEmail;